import React, { FC } from 'react';

import { RenderImage } from '@v2/pages/machines/common/components/Item/RenderImage';
import type { ImageData } from '@v2/context/Image/context/interfaces';
import type { MachineStatus } from '@interfaces/machines';
import type { RenderImageProps } from '@v2/pages/machines/common/types/props';

import { ImageWrapper, type ImageWrapperProps } from '@components/machines/components/detailsComponents/activeMachine/components/Images/components/ImageWrapper';

export interface MachineImageProps
  extends Pick<
      ImageWrapperProps,
      'C' | 'isImageHandlingNavigation' | 'panelViewMode' | 'scale' | 'onImagePress' | 'imageDocumentId'
    >,
    Pick<RenderImageProps, 'imageLink'> {
  imageRandomHash: MachineStatus['imageRandomHash'];
  imageData: Pick<ImageData, 'isCropped'>;
  imageRotationAngle: ImageData['rotationAngle'];
  machineId?: number | null;
}

export const MachineImage: FC<MachineImageProps> = ({
  imageLink,
  imageRandomHash,
  imageData,
  imageRotationAngle,
  isImageHandlingNavigation,
  imageDocumentId,
  machineId,
  panelViewMode,
  scale,
  C,
  onImagePress,
}) => {
  return (
    <ImageWrapper
      C={C}
      isImageHandlingNavigation={isImageHandlingNavigation}
      panelViewMode={panelViewMode}
      scale={scale}
      documentRetrieveKey="Machine"
      documentRetrieveId={machineId}
      index={0}
      imageDocumentId={imageDocumentId}
      onImagePress={onImagePress}
    >
      <RenderImage
        uploadedImage={null}
        imageLink={imageLink}
        imageRandomHash={imageRandomHash}
        rotationAngle={imageData?.isCropped ? 0 : imageRotationAngle}
        C={C}
      />
    </ImageWrapper>
  );
};
